/** Katrina's Reddit marketer onboarding niche taxonomy (must match backend). */
export const GUIDE_NICHES = [
  'Agriculture & Farming',
  'Apparel, Accessories & Jewelry',
  'Automotive',
  'Baby & Kids',
  'Business, Legal & Professional Services',
  'Education & Learning',
  'Electronics & Technology',
  'Food, Beverage & Tobacco',
  'Health, Medical & Wellness',
  'Hobbies, Crafts & Games',
  'Home Improvement & Services',
  'Home & Living',
  'Industrial & Manufacturing',
  'Media, Sports & Entertainment',
  'Office & Stationery',
  'Pets & Pet Care',
  'Science & Laboratory',
  'Sporting Goods, Tactical & Outdoors',
  'Travel & Tourism',
  'Gifts & Occasions',
];

export const MAX_CLIENT_GUIDE_NICHES = 4;
